<form [formGroup]="parentForm()" ngNativeValidate>
  <div class="toggle">
    <!--
      User-toggleable control bound to the parent form via formControlName.
    -->
    <mat-slide-toggle
      formControlName="isAdvertised"
      aria-describedby="adv-hint">
      <span class="label">Advertise in the Marketplace</span>
    </mat-slide-toggle>
    <div class="hint" id="adv-hint">
      When enabled, this {{ itemType() }} appears in the Marketplace and requires owner approval when users request access.
    </div>
  </div>

  @if (showMarketplaceSettings()) {
  <fieldset>
    <legend>Access control</legend>
  <div class="toggle">
    <!--
      User-toggleable control bound to the parent form via formControlName.
      Disabled state is controlled based on isAdvertised value:
      - When isAdvertised is false: this toggle is disabled
      - When isAdvertised is true: this toggle is enabled and user can toggle it
    -->
    <mat-slide-toggle
      formControlName="isAutoApproved"
      aria-describedby="auto-hint">
      <span class="label">Auto-approve requests to use</span>
    </mat-slide-toggle>
    <div class="hint" id="auto-hint">
      When enabled, user access requests are approved automatically without owner review.
    </div>
    <div class="hint" id="auto-hint">
      When disabled, all owners will receive an email notification when a user requests access to this {{ itemType() }}.
    </div>
  </div>
  <mat-divider></mat-divider>
  <div class="toggle">
    <!--
      User-toggleable control bound to the parent form via formControlName.
      Disabled state is computed based on isAutoApproved value:
      - When isAutoApproved is false: this toggle is disabled
      - When isAutoApproved is true: this toggle is enabled and user can toggle it
    -->
    <mat-slide-toggle
      formControlName="notifyAutoApproval"
      aria-describedby="notify-hint">
      <span class="label">Notify when auto-approved</span>
    </mat-slide-toggle>
    <div class="hint" id="notify-hint">
      When enabled, owners receive a notification when access is automatically approved.
    </div>
  </div>
  </fieldset>
  }
</form>
